function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "var(--primary-color)",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.19232 17.445816 3.9031615 10.60243m8.2891585 6.843386 8.000004-6.843386m-8.192774 6.361447V3.7e-7",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "var(--primary-color)",
      strokeWidth: 5.15826,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(1.9763644 2.1459164) scale(.83203125)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6140014 24.000001H20.385093",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "var(--primary-color)",
      strokeWidth: 4.53188,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(1.9763644 2.1459164) scale(.83203125)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstall);
export default __webpack_public_path__ + "static/media/install.f85e8dca45d0d092153cc0f6618977e3.svg";
export { ForwardRef as ReactComponent };